import ReactCountUp from 'react-countup'

import styled, { css } from 'styled-components'

import { THeaderStyle } from './types'

const Wrapper = styled.div<THeaderStyle>`
  position: fixed;
  background: ${p => p.background};
  color: ${p => p.color};
  height: 60px;
  width: calc(100% - 20px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 10px;
  z-index: 100;
  box-shadow: 8px 1px 15px rgba(0, 0, 0, 0.06);
  outline: none;
  border: 0;
  user-select: none;
`
const LeftContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
`
const UserAvatarWrapper = styled.div`
  display: flex;
  align-items: center;

  span {
    height: 15px;
    padding: 0 10px;
  }
`
const UserName = styled.div`
  font-size: 0.8rem;
  margin-left: 7px;
  font-weight: 600;
`

const UserAvatarBase = css`
  width: 35px;
  height: 35px;
  border-radius: 50px;
`

const UserAvatar = styled.img`
  ${UserAvatarBase}
`

const UserAvatarName = styled.div`
  ${UserAvatarBase};
  background: ${p => p.theme.colors.light};
  color: ${p => p.theme.colors.dark};
  font-weight: bolder;
  display: flex;
  justify-content: center;
  align-items: center;
`

const PageTitle = styled.h2`
  font-family: ${p => p.theme.fonts.tertiary};
  font-size: 0.9rem;
  margin-left: 8px;
  font-weight: 500;
`

// const Score = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   font-family: ${p => p.theme.fonts.tertiary};

//   div {
//     font-size: 0.6rem;
//     font-weight: 500;
//     opacity: 0.7;
//     margin-top: -2px;
//   }
// `

const CountUp = styled(ReactCountUp)`
  font-size: 1.8rem;
  font-weight: 500;
`

export {
  Wrapper,
  LeftContainer,
  RightContainer,
  UserName,
  UserAvatar,
  UserAvatarName,
  PageTitle,
  UserAvatarWrapper,
  CountUp,
}
